import type {EventContainerWithEvents} from "~/utilities/apis/api";

export function getLatestEventsForEventContainer(args: {
    eventContainer: EventContainerWithEvents;
}): EventContainerWithEvents {
    const latestEventByTemplateId = new Map<string, EventContainerWithEvents["events"][number]>();

    for (const event of args.eventContainer.events) {
        const existingEvent = latestEventByTemplateId.get(event.templateId);
        if (existingEvent === undefined) {
            latestEventByTemplateId.set(event.templateId, event);
        } else if (new Date(event.createdAt) > new Date(existingEvent.createdAt)) {
            latestEventByTemplateId.set(event.templateId, event);
        }
    }

    return {
        ...args.eventContainer,
        events: Array.from(latestEventByTemplateId.values()),
    };
}
